var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetroStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.19,
    height: 73.666,
    viewBox: "0 0 84.19 73.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-stack",
    "data-name": "Icon metro-stack",
    d: "M86.76,24.9,44.666,3.856,2.571,24.9,44.666,45.951ZM44.666,10.842,72.788,24.9,44.666,38.965,16.543,24.9ZM78.329,36.473l8.432,4.216L44.666,61.737,2.571,40.689,11,36.473,44.666,53.3Zm0,15.786,8.432,4.216L44.666,77.522,2.571,56.475,11,52.259,44.666,69.09Z",
    transform: "translate(-2.571 -3.856)",
    fill: "#9b35ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroStack);
export default __webpack_public_path__ + "static/media/metro-stack.85f176efe69f40981f6ec2b1cd0c9168.svg";
export { ForwardRef as ReactComponent };